import { Button, Card, Empty, Tooltip } from "antd";
import React from "react";
import PreventivoRoom from "./PreventivoRoom";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import preventiviService from "../../services/preventivi.service";
import dayjs from "dayjs";

import styled from "styled-components";

const TabsHeader = styled.div`
  display: flex;
  gap: 4px;
  border-bottom: 1px solid #ddd;
`;

const Tab = styled.button`
  padding: 6px 12px;
  background: #f5f5f5;
  border: none;
  cursor: pointer;

  &.active {
    background: white;
    border-bottom: 2px solid blue;
    font-weight: bold;
  }
`;


function PreventivoRoomOffers({ preventivo, setPreventivo }) {
    const { token } = useParams();


    function modificaPermessa() {
        return preventivo.status !== 2 && preventivo.status !== 3 && preventivo.status !== 4
    }

    async function deleteAllRowsOfOffer(righe) {
        righe.forEach((row) => {
            const id = row.id_preventivo_row;
            preventiviService.deleteRowRoom(token + "/" + id)
        })
    }

    async function moveAllOffersBackByOne(righe) {
        righe.forEach((row) => {
            const id = row.id_preventivo_row;
            let newRoomOffer = row.num_offer
            if (row.num_offer > 0) {
                newRoomOffer -= 1;
            }
            preventiviService.patchRowDates(token, {
                date_from_patch: dayjs(row.date_from).toISOString(),
                date_to_patch: dayjs(row.date_to).toISOString(),
                id_booking_room: row.id_booking_room,
                id_preventivo_row: row.id_preventivo_row,
                id_preventivo: row.id_preventivo,
                striked_price: row.striked_price,
                price: row.price,
                num_offer: newRoomOffer,
            })
        })
    }


    return (
        <Card
            title={<>
                {(preventivo.offers?.length ? preventivo.offers : [[null]]).map((_, index) => (
                    <Tab
                        className={preventivo.selectedOffer == index ? "active" : ""}
                        onClick={() => {
                            console.log("Room offers")
                            console.log(preventivo.offers)
                            console.log("Rows")
                            console.log(preventivo.rows)
                            setPreventivo(prev => ({ ...preventivo, selectedOffer: index }))
                        }}
                    >
                        <span
                            style={{ color: preventivo.selected_offer != null ? (preventivo.selected_offer == index ? "green" : "red") : "inherit"}}
                        >{"Proposta " + (index + 1) + (preventivo.selected_offer == index ? " (accettata)" : "")}</span>
                        {index > 0 && modificaPermessa() && (
                            <button
                                style={{ color: "red" }}
                                className="ml-2"
                                onClick={(e) => {
                                    e.stopPropagation(); //Prevent selecting the tab
                                    deleteAllRowsOfOffer(preventivo.rows.filter(row => row.num_offer == index))
                                    moveAllOffersBackByOne(preventivo.rows.filter(row => row.num_offer > index))
                                    if (preventivo.selectedOffer == index || preventivo.selectedOffer >= preventivo.offers.length - 1) { setPreventivo(prev => ({ ...preventivo, selectedOffer: prev.selectedOffer - 1})) }
                                    console.log("Rows before")
                                    console.log(preventivo.rows)
                                    let newRows = preventivo.rows.filter(row => row.num_offer != index)
                                    console.log("Rows filter1")
                                    console.log(newRows)
                                    newRows.forEach(row => {
                                        if (row.num_offer > index) row.num_offer--;
                                    })
                                    console.log("Rows filter2")
                                    console.log(newRows)
                                    let newOffers = preventivo.offers.filter((_, indexPrev) => indexPrev != index)
                                    newRows.forEach(offer => {
                                        if (offer.length > 0) {
                                            offer.forEach(row => {
                                                if (row.num_offer > index) row.num_offer--;
                                            })
                                        }
                                        
                                    })
                                    setPreventivo(prev => ({
                                        ...prev,
                                        rows: newRows,
                                        offers: newOffers.filter(offer => offer.length > 0)
                                    }))
                                    
                                }}
                            >
                                x
                            </button>
                        )}
                        
                    </Tab>
                ))}
                {preventivo.offers?.length < 7 && modificaPermessa() && (
                    <button
                        style={{ color: "blue" }}
                        onClick={() => {
                            if (preventivo.offers?.length == 0) { //se ne avevi 0 e ne crei un altro, deve essere 2.
                                setPreventivo(prev => ({
                                    ...prev, selectedOffer: prev.offers.length, offers: [...prev.offers, [], []],
                                }));
                            } else {
                                setPreventivo(prev => ({
                                    ...prev, selectedOffer: prev.offers.length, offers: [...prev.offers, []],
                                }));
                            }
                            
                    }} className="tab add-tab">
                        +
                    </button>
                )}
                
            </>
}
            bordered={false}
            className="max-h-[500px] overflow-y-auto"
        >
            <PreventivoRoom
                preventivo={preventivo}
                setPreventivo={setPreventivo}
            />
        </Card>
    );
}

export default PreventivoRoomOffers;
